import { toast } from "react-toastify";

export const APP_URL = `${process.env.REACT_APP_API_V2_URL}/settings/application/pos`;
export const PERIPHERALS_URL = `${process.env.REACT_APP_API_V2_URL}/settings/application/pos/peripherals`;
export const MONETIC_URL = `${process.env.REACT_APP_API_V2_URL}/settings/application/pos/monetic/general`;
export const CURRENCIES_URL = `${process.env.REACT_APP_API_V2_URL}/settings/general/currencies/symbol`;
export const MODE_OF_SALE_URL = `${process.env.REACT_APP_API_V2_URL}/settings/general/mode_of_sale`;
export const MONETICS_URL = `${process.env.REACT_APP_API_V2_URL}/settings/monetics`;
export const MONETICS_CONFIG_URL = `${process.env.REACT_APP_API_V2_URL}/settings/monetics/configuration`;
export const APPLICATIONS_URL = `${process.env.REACT_APP_API_V2_URL}/settings/applications/pos`;
export const PRINTER_HISTORY_URL = `${process.env.REACT_APP_API_V2_URL}/settings/printers/printer/history`;

export const APP_ID = "POS";

export const DATE_FORMAT = "DD/MM/YYYY [at] HH:mm a";
export const HOUR_FORMAT = "DD/MM/YY - HH:mm a";

export enum DeviceType {
    PRINTER = "printer",
    MONETIC = "monetic",
    CASH_MANAGEMENT = "cash_management",
}

export enum ActionType {
    ADD = "Add",
    ARCHIVE = "Archivage",
    UNARCHIVE = "Désarchivage",
}

export const PERIPHERAL_ID_KEYS: Record<DeviceType, string> = {
    [DeviceType.PRINTER]: "id_printer",
    [DeviceType.MONETIC]: "id_monetic",
    [DeviceType.CASH_MANAGEMENT]: "id_cash_management",
};

export const TOAST_OPTIONS = {
    position: toast.POSITION.TOP_CENTER,
    autoClose: 2000,
    theme: "colored" as const,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
};
